import { Platform } from 'react-native';

import {
  generateAnonymousUserContext,
  generateUserContext,
  type LaunchDarklyContext,
} from '@sg/launch-darkly';

import { APP_CONTEXT, legacy_CUSTOM_ATTRIBUTES } from './useLaunchDarklyIntegration.constants';
import { type Customer } from './useLaunchDarklyIntegration.types';

// ─────────────────────────────────────────────────────────────────────────────

export function generateInitialContext(customer: Customer) {
  return {
    user: generateCustomerContext(customer),
    app: APP_CONTEXT,

    // NOTE: Native device context is handled by the native SDK AutoEnvAttributes.Enabled
    // we need to manually add the same context for web users.
    ...(Platform.OS === 'web' ? { ld_device: { anonymous: true } } : {}),
  } satisfies Record<string, LaunchDarklyContext>;
}

function generateCustomerContext(customer: Customer): LaunchDarklyContext {
  const customerId = customer.id;

  if (customerId) {
    return {
      ...generateUserContext({ customer: { id: customerId, email: customer.email } }),
      ...legacy_CUSTOM_ATTRIBUTES,
    };
  }

  return {
    anonymous: true,
    ...generateAnonymousUserContext(),
    ...legacy_CUSTOM_ATTRIBUTES,
  };
}
